import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import { Label, OverlayTrigger, Glyphicon, Popover } from 'reaxl';

/**
 *  Displays an inventory label indicating that the listing is newly listed
 *  It optionally provides an overlay with additional information when interacted with.
 */
function NewlyListed(_ref) {
  let {
    bsStyle = 'brand',
    description,
    enableOverlay = false,
    label = 'Newly Listed',
    ...rest
  } = _ref;
  const labelComponent = /*#__PURE__*/React.createElement(Label, Object.assign({
    "data-cmp": "newlyListed",
    bsStyle: bsStyle
  }, rest), label, enableOverlay && !!description && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "info",
    className: "margin-left-1 text-valign-baseline"
  }))));
  if (enableOverlay && !!description) {
    return /*#__PURE__*/_jsx(OverlayTrigger, {
      "aria-label": "Newly Listed",
      className: "cursor-pointer",
      placement: "top",
      rootClose: true,
      trigger: "click",
      overlay: /*#__PURE__*/_jsx(Popover, {
        id: "contextual-help-newly-listed",
        width: "narrow"
      }, void 0, description)
    }, void 0, labelComponent);
  }
  return labelComponent;
}
export default NewlyListed;